import * as mutationTypes from './mutation-types'

const Timeline = {
  state() {
    return {
      timelineData: {
        bookyearEndDates: [],
        ledgers: [],
      },
    }
  },

  getters: {
    timelineData: (state) => {
      return state.timelineData
    },
  },

  mutations: {
    [mutationTypes.SET_TIMELINE_DATA](state, data) {
      state.timelineData = data
    },
  },
}

export default Timeline
